<form class="flex justify-between">
    <input
        #inputEl
        *ngFor="let input of inputsForm.controls; let i = index"
        (focus)="handleFocus($event)"
        (blur)="onTouched?.()"
        (keypress)="handleKeyPress($event, i)"
        (input)="handleInput()"
        (keydown)="handleKeyDown($event, i)"
        (paste)="handlePaste($event, i)"
        [formControl]="$any(input)"
        [attr.autocomplete]="i === 0 ? 'one-time-code' : null"
        type="text"
        inputmode="numeric"
        class="size-12 text-lg text-center rounded-lg border border-solid border-[#D1D1D1] focus:outline-none"
    />
</form>